<main *ngIf="pageError">
  <div class="alert valign-children-middle page-error">
    <div class="alert-error" role="img" aria-label="Error">
      <i class="icon-badgealert"></i>
    </div>
    <div>
      <span>{{ errorMessage }}</span>
    </div>
    <div class="pull-right close" (click)="dismissInfo()" role="img" aria-label="close"></div>
  </div>
</main>
<main *ngIf="manageInventoryPage" class="manage-inventory">
  <h1>{{ manageInventoryPage.pageHeader }}</h1>

  <div *ngIf="errMsgDisplay" class="alert valign-children-middle page-error">
    <div class="alert-error" role="img" aria-label="Error">
      <i class="icon-badgealert"></i>
    </div>
    <div>
      <span>We are still finalizing your account set up for
        <span>{{ activeFanId }}</span>. Newly enrolled devices will be displayed after enrollment is
        completed. This could take up to 1 business day.</span>
    </div>
    <button class="close" (click)="errMsgDisplay = !errMsgDisplay" aria-label="Close"></button>
  </div>
  <div class="alert valign-children-middle page-error" *ngIf="showError">
    <div class="alert-error" role="img" aria-label="Error">
      <i class="icon-badgealert"></i>
    </div>
    <div>
      <span>{{ errorMessage }}</span>
      <div class="pull-right close" (click)="dismissError()" aria-label="Close"></div>
    </div>
  </div>
  <!-- displaying changeorgid error message -->
  <div *ngIf="showNeworgidFailureError" class="container-box" id="error-container">
    <div class="alert valign-children-middle mar-top-20" id="alert-container">
      <div class="alert-error" aria-label="Alert." id="alert-error-container">
        <i class="icon-badgealert" aria-hidden="true"></i>
      </div>
      <div id="error-message-container">
        <!-- <h2 tabindex="-1" id="error-heading">Error</h2> -->
        <h2>Error</h2>
        <p>
          Organization ID update failed. Check entry and retry. If issue
          continues, contact support at 866.563.4703 .
        </p>
      </div>
      <div class="pull-right close" (click)="dismissInfo()" role="img" aria-label="close"></div>
    </div>
  </div>
  <!-- displaying changeorgid success message -->
  <div *ngIf="showNeworgidError" id="success-main-container">
    <div class="container-box" id="success-container">
      <div class="alert valign-children-middle" id="alert-success-container">
        <div class="alert-success">
          <i class="icon-approval" aria-hidden="true"></i>
        </div>
        <div id="success-message-container">
          <!-- <h2 tabindex="-1" id="success-heading">success</h2> -->
          <h2>Success</h2>
          <p>Your Apple Organization ID has been updated. </p>
        </div>
        <div class="pull-right close" (click)="dismissInfo()" role="img" aria-label="close"></div>
      </div>
    </div>
  </div>
  <!-- displaying error message -->
  <div *ngIf="showNewFailureError" class="container-box" id="error-container">
    <div class="alert valign-children-middle mar-top-20" id="alert-container">
      <div class="alert-error" aria-label="Alert." id="alert-error-container">
        <i class="icon-badgealert" aria-hidden="true"></i>
      </div>
      <div id="error-message-container">
        <!-- <h2 tabindex="-1" id="error-heading">Error</h2> -->
        <p id="error-message">Error</p>
        <p id="error-message">
          Notification settings update failed. Check entry and retry. If issue
          continues, contact support at 866.563.4703 .
        </p>
      </div>
      <div class="pull-right close" (click)="dismissInfo()" role="img" aria-label="close"></div>
    </div>
  </div>
  <!-- displaying success message -->
  <div *ngIf="showNewError" id="success-main-container">
    <div class="container-box" id="success-container">
      <div class="alert valign-children-middle" id="alert-success-container">
        <div class="alert-success">
          <i class="icon-approval" aria-hidden="true"></i>
        </div>
        <div id="success-message-container">
          <!-- <h2 tabindex="-1" id="success-heading">success</h2> -->
          <p id="success-message">Success</p>
          <p>Notification settings updated successfully.</p>
        </div>
        <div class="pull-right close" (click)="dismissInfo()" role="img" aria-label="close"></div>
      </div>
    </div>
  </div>
  <div class="alert valign-children-middle" *ngIf="smsSent">
    <div class="alert-success">
      <i class="icon-approval" role="img" aria-label="Success"></i>
    </div>
    <div>Your message has been sent.</div>
    <div class="pull-right close" (click)="dismissInfo()" role="img" aria-label="Close"></div>
  </div>
  <section aria-label="Accout summary" class="panel panel-header" *ngIf="showView">
    <div class="flex-container">
      <div class="chart-container">
        <app-donut-chart [data]="donutChartData" [r]="chartRadius" [label]="chartLabel" [stroke_width]="strokeWidth"
          [error]="chartError" *ngIf="donutChartData">
        </app-donut-chart>
      </div>

      <div class="chart-legend-container chart-legends">
        <app-legend *ngIf="!chartError" [data]="donutChartData"></app-legend>
        <!-- <button  (click)="navigate('/productselection')" class="addAccountBtn" type="button">Add accounts</button> -->
        <button *ngIf="isDisabled === true" (click)="navigate('/productselection')" class="addAccountBtnDisabled"
          type="button" disabled>
          Register accounts
        </button>
        <button *ngIf="isDisabled === false" (click)="navigate('/productselection')" class="addAccountBtn"
          type="button">
          Register accounts
        </button>

        <div class="cancel-participation-link" *ngIf="!oemStatus" [ngClass]="{
            'disable-cursor': manageInventoryPage.cancelParticipation.disable
          }" [attr.aria-disabled]="manageInventoryPage.cancelParticipation.disable">
          <a routerLink="/cancelParticipation" class="removeAccount" [ngStyle]="{ 'letter-spacing': '0.53px' }"
            [ngClass]="{
              'disable-anchor': manageInventoryPage.cancelParticipation.disable || disableRemoveLink
            }">{{ manageInventoryPage.cancelParticipation.label }}</a>
        </div>
        <div class="cancel-participation-link" *ngIf="oemStatus" [ngClass]="{
            'disable-cursor': disableRemoveLink
          }" [attr.aria-disabled]="disableRemoveLink">
          <a (click)="navigate('/cancelParticipation/removeaccount')" routerLink="/cancelParticipation/removeaccount"
            class="removeAccount" [ngStyle]="{ 'letter-spacing': '0.53px' }" [ngClass]="{
              'disable-anchor': disableRemoveLink
            }">{{ manageInventoryPage.cancelParticipation.label }}</a>
        </div>
        <div class="apple-cert" *ngIf="manageInventoryPage.appleCertificate.label && !oemStatus">
          <i class="icon-alert iconNI" role="img" aria-label="Alert" *ngIf="
              manageInventoryPage.appleCertificate.label ==
                'Apple certificate not installed' ||
              manageInventoryPage.appleCertificate.label ==
                'Apple certificate nearing expiration'
            "></i>
          <i class="icon-alert iconE" role="img" aria-label="Alert" *ngIf="
              manageInventoryPage.appleCertificate.label ==
              'Apple certificate has expired'
            "></i>
          <i class="icon-alert iconP" role="img" aria-label="Alert" *ngIf="
              manageInventoryPage.appleCertificate.label ==
              'Apple certificate in process'
            "></i>
          <i class="icon-approval iconI" role="img" aria-label="Alert" *ngIf="
              manageInventoryPage.appleCertificate.label ==
              'Apple certificate installed'
            "></i>
          <a routerLink="{{ manageInventoryPage.appleCertificate.route }}"
            [checkRole]="manageInventoryPage.appleCertificate.fieldPermission">{{
            manageInventoryPage.appleCertificate.label }}</a>
        </div>
      </div>
    </div>
    <div class="nav-container-inventory" *ngIf="donutChartData && !oemStatus">
      <ul class="nav-icons">
        <li *ngFor="let nav of manageInventoryPage.navIcons">
          <button class="link-button" *ngIf="nav.fieldPermission == 'manageInventory.report'" type="button"
            [title]="nav.title ? nav.title : ''" (click)="navigate(nav.route)" [disabled]="disableRemoveLink">
            <figure>
              <img [src]="disableRemoveLink ? nav.disabledImgUrl : nav.imgUrl" [alt]="nav.label" />
            </figure>
            <a [innerHtml]="nav.label"></a>
          </button>
          <button class="link-button" *ngIf="nav.fieldPermission != 'manageInventory.report'" type="button"
            [title]="nav.title ? nav.title : ''" (click)="navigate(nav.route)" [disabled]="nav.disable">
            <figure>
              <img [src]="nav.imgUrl" [alt]="nav.label" />
            </figure>
            <a [innerHtml]="nav.label"></a>
          </button>
        </li>
      </ul>
    </div>
    <div class="nav-container-inventory" *ngIf="donutChartData && oemStatus">
      <ul class="nav-icons">
        <li *ngFor="let nav of manageInventoryPage.navIconsOem">
          <button class="link-button" *ngIf="nav.fieldPermission == 'manageInventory.report'" type="button"
            [title]="nav.title ? nav.title : ''" (click)="navigate(nav.route)" [disabled]="disableRemoveLink">
            <figure>
              <img [src]="disableRemoveLink ? nav.disabledImgUrl : nav.imgUrl" [alt]="nav.label" />
            </figure>
            <a [innerHtml]="nav.label"></a>
          </button>
          <button class="link-button" *ngIf="nav.fieldPermission != 'manageInventory.report'" type="button"
            [title]="nav.title ? nav.title : ''" (click)="navigate(nav.route)" [disabled]="nav.disable">
            <figure>
              <img [src]="nav.imgUrl" [alt]="nav.label" />
            </figure>
            <a [innerHtml]="nav.label"></a>
          </button>
        </li>
      </ul>
    </div>
  </section>
  <!--Fan level Deployment status-->
  <section aria-label="Devices summary" *ngIf="showView">
    <div *ngIf="!oemStatus">
      <h2 class="fontsize">{{ manageInventoryPage.subHeader }}</h2>
    </div>
    <div *ngIf="oemStatus">
      <h2 class="fontsize">{{ manageInventoryPage.subHeaderOEM }}</h2>
    </div>
    <div class="search-fan-container">
      <span>
        Showing {{ totalRecords > 0 ? 0 + 1 : 0 }} -
        {{
        startIndex + recordsPerPage > totalRecords
        ? totalRecords
        : startIndex + recordsPerPage
        }}
        of {{ totalRecords }}
      </span>
      <!-- <span [ngClass]="{'disable-cursor' : manageInventoryPage.report.disable}">
         <a (keydown.enter)="navigate(manageInventoryPage.report.route)" (click)="navigate(manageInventoryPage.report.route)" [ngClass]="{'disable-anchor' : manageInventoryPage.report.disable}"
          [attr.aria-disabled]="manageInventoryPage.report.disable" [ngStyle]="{'cursor': 'pointer'}" tabindex="0">{{manageInventoryPage.report.label}}</a>
      </span> -->
      <div class="search-fans" *ngIf="totalRecords > recordsPerPage || isSearch">
        <div class="search-input">
          <input type="search" OnlyNumber [formControl]="fanSearch" class="form-control"
            (keydown.enter)="handleSearchClick()" placeholder="Enter full foundation account number" />
          <span class="search-icon" tabindex="0" (keydown.enter)="handleSearchClick()" (click)="handleSearchClick()">
            <i class="icon-controls-magnifyingglass" aria-label="search."></i>
          </span>
        </div>
        <div class="clear-search" *ngIf="isSearch">
          <a href="javascript:void(0);" (click)="viewAllAccounts()">View all accounts</a>
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="no-result" *ngIf="fanDevicesSummary.devicesSummary.length == 0">
        <article tabindex="0">
          <section aria-labelledby="fanSearchNoResults">
            <p id="fanSearchNoResults">No Results</p>
            <p>
              We didn't find any foundation account that matches your search.
              Please provide full account name.
            </p>
          </section>
        </article>
        <div class="clearfix"></div>
      </div>
    </div>
    <div class="component-container" *ngIf="fanDevicesSummary">
      <app-device-summary class="fans-list" *ngFor="let data of fanDevicesSummary.devicesSummary | slice : 0 : 9"
        [data]="data"></app-device-summary>
      <div class="clearfix"></div>
    </div>
    <div class="text-center pagination-position pagination" *ngIf="totalRecords > recordsPerPage">
      <app-pagination [startIndex]="startIndex" [totalRecords]="totalRecords" [recordsPerPage]="recordsPerPage"
        (pageChange)="onPageChange($event)"></app-pagination>
    </div>
  </section>
  <section aria-labelledby="notEligibleContainer" *ngIf="!showView">
    <div class="not-eligible-container">
      <div class="top-container">
        <ng-container *ngIf="envPortal !== 'fnabc'; else fnInEligibelTemplate">
          <div *ngIf="showNotEligible">
            <h4>No Eligible Foundation Accounts</h4>
            <div>
              You have no eligible foundation accounts available to be added.
            </div>
          </div>
          <!-- <div *ngIf="showUnknown">
            <h4>Unable to access Accounts</h4>
            <div>We are unable to access your account at this time. Please try again later.</div>
          </div> -->
        </ng-container>
        <ng-template #fnInEligibelTemplate>
          <div *ngIf="showNotEligible">
            <h4>
              {{ manageInventoryPage.handlePermission.ineligibleContent.title }}
            </h4>
            <div>
              {{
              manageInventoryPage.handlePermission.ineligibleContent.message
              }}
            </div>
          </div>
          <!-- <div *ngIf="showUnknown">
            <h4>{{ manageInventoryPage.handlePermission.unknownContent.title }}</h4>
            <div>{{ manageInventoryPage.handlePermission.unknownContent.message }}</div>
          </div> -->
        </ng-template>
      </div>
      <!-- Commenting out learn more button as a part of US-1367
      <div class="bottom-container text-center">
        <button (click)="navigate('learn')" class="btn btn-default" type="button">
          Learn more
        </button>
      </div> -->
    </div>
  </section>
  <div *ngIf="showPopup">
    <app-modal [showModal]="showPopup" [modalClass]="modalClass">
      <app-ctnlookup-modal [modalPopupObject]="popupModal" [triggerElement]="eventEmit"
        (modalOutput)="closePopup($event)">
      </app-ctnlookup-modal>
    </app-modal>
  </div>
  <!-- IMEI popup functionality -->
  <div *ngIf="showImeiPopup">
    <app-modal [showModal]="showImeiPopup" [modalClass]="modalClass">
      <app-imeilookup-modal [modalPopupObject]="imeipopupModal" [triggerElement]="eventEmit"
        (modalOutput)="closeImeiPopup($event)">
      </app-imeilookup-modal>
    </app-modal>
  </div>
  <!--Report pop up functionality -->
  <div *ngIf="showReportPopup">
    <app-modal [showModal]="showReportPopup" [modalClass]="modalClass">
      <app-report [modalPopupObject]="overviewModalPopup" [triggerElement]="eventEmit"
        (modalOutput)="closeReportPopup($event)">
      </app-report>
    </app-modal>
  </div>
  <div *ngIf="showOverviewModal">
    <app-modal [showModal]="showOverviewModal" [modalClass]="modalClass">
      <div class="model-cover terms">
        <div class="model-box">
          <div class="modal-header">
            <div class="corner-button">
              <button class="close" aria-label="Close" (click)="closeOverviewModal()">
                x
              </button>
            </div>
            <att-gvp [attr.video]="videoId"></att-gvp>
          </div>
        </div>
      </div>
    </app-modal>
  </div>
  <!-- <div class="accordion-section" *ngIf="!oemStatus && supportArticle">
    <app-accordion [accordion]="options" [accordionController]=false>
      <app-accordion-list *ngFor="let option of options; let i=index " [option]='option' [isSubAccordion]=true>
              <div class="support-content mediaStop" id="player" *ngFor="let article of this.article.availableArticle; let i=index"> -->
  <!-- <a href="javascript:void(0)"  (click)="getSupportContent(i)" >{{article.name}}</a> -->
  <!-- <att-gvp *ngIf="article.url" [attr.video]="article.url" ></att-gvp>
              </div>
    </app-accordion-list>
  </app-accordion>
  </div> -->
</main>
<app-mobile-pivot [pivots]="pivots"></app-mobile-pivot>